import {
  createRequiredText,
  validateCrf,
  validateDate,
  validateDdd,
  validateEmail,
  validateCpf,
  validateName,
  validatePassword,
  validatePhoneNumber,
  checkExactLength,
  checkOnlyNumber,
} from '../custom';

export const cpfValidation = {
  required: createRequiredText(),
  validate: {
    validCpf: validateCpf,
  },
};

export const birthDateValidation = {
  required: createRequiredText(),
  validate: {
    validDate: validateDate,
  },
};

export const nameValidation = {
  required: createRequiredText(),
  validate: {
    validName: validateName,
  },
};

export const crfValidation = {
  required: createRequiredText(),
  validate: {
    validCrf: validateCrf,
  },
};

export const dddValidation = {
  required: createRequiredText(),
  validate: {
    validDdd: validateDdd,
  },
};

export const phoneNumberValidation = {
  required: createRequiredText(),
  validate: {
    validPhoneNumber: validatePhoneNumber,
  },
};

export const emailValidation = {
  required: createRequiredText(),
  validate: {
    validEmail: validateEmail,
  },
};

export const passwordValidation = {
  required: createRequiredText(),
  validate: {
    validPassword: validatePassword,
  },
};

export const cepValidation = {
  required: createRequiredText(),
  validate: {
    exactLength: (value: string) => checkExactLength(value, 9, 'Deve ter 8 números'),
  },
};

export const addressValidation = {
  required: createRequiredText(),
};

export const numberHouseValidation = {
  required: createRequiredText(),
  validate: {
    onlyNumber: (value: string) => checkOnlyNumber(value),
  },
};

export const cityValidation = {
  required: createRequiredText(),
};

